import { API, ApiPrefixes } from "../../api";
const BASE_URL = ApiPrefixes["adminPortalSettings"];

const portalApi = API.injectEndpoints({
  endpoints: (builder) => ({
    updatePortal: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}?guard=staff`,
        method: "PATCH",
        body: body,
      }),
    }),
  }),
});

export const { useUpdatePortalMutation } = portalApi;
